module.exports = __webpack_public_path__ + "static/media/com-canela.7d6521bc.png";